import type { CartDto } from '@cineamo/api/models/cart/CartDto.types';
import type { OrderDto } from '@cineamo/api/models/order/OrderDto.types';

type RefusedConcessionsOrder = Pick<
    OrderDto,
    'concessionsRefusedReason' | 'refusedConcessionsAmount' | 'refusedConcessionsRefundedDatetime'
>;

/** The ticket system booked the tickets but refused the concessions: all of them, never single lines. */
export function hasRefusedConcessions(order: Pick<OrderDto, 'concessionsRefusedReason'>): boolean {
    return !!order.concessionsRefusedReason;
}

/** `pending` covers a refund still in flight and a failed one; operations then refunds by hand. */
export function refusedConcessionsRefundStatus(order: RefusedConcessionsOrder): 'refunded' | 'pending' {
    return order.refusedConcessionsRefundedDatetime ? 'refunded' : 'pending';
}

/** Customer success screen: the cart carries only the refunded amount, never the technical reason. */
export function getRefusedConcessionsRefund(
    cart: Pick<CartDto, 'refusedConcessionsAmount'> | null | undefined
): number | null {
    const amount = cart?.refusedConcessionsAmount;
    return amount != null && amount > 0 ? amount : null;
}
